import { render } from "./waterfalls.vue?vue&type=template&id=e039ab9e&scoped=true"
import script from "./waterfalls.vue?vue&type=script&lang=js"
export * from "./waterfalls.vue?vue&type=script&lang=js"

import "./waterfalls.vue?vue&type=style&index=0&id=e039ab9e&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e039ab9e"]])

export default __exports__